// extracted by mini-css-extract-plugin
export var avatarContainer = "_6g-0";
export var avatarTypingWave = "_6g-i";
export var gray = "_6g-f";
export var green = "_6g-c";
export var icon = "_6g-9";
export var image = "_6g-1";
export var lg = "_6g-6";
export var md = "_6g-5";
export var presenceDot = "_6g-b";
export var red = "_6g-d";
export var sm = "_6g-4";
export var status = "_6g-a";
export var typingDot = "_6g-h";
export var typingPill = "_6g-g";
export var xl = "_6g-7";
export var xs = "_6g-3";
export var xxl = "_6g-8";
export var xxs = "_6g-2";
export var yellow = "_6g-e";